/**
 * Offset from the top used for scrolling purposes.
 * toolbar 64px + navbar 49px = offsetY 113px
 */
export const projectDetailsOffset = 113;
